import img1 from './assets/img1.png'
import img2 from './assets/img2.png'
import img3 from './assets/img3.png'
 const  serviceData=[
    {img:img1,id:"service1", text:"Trusted Company",desc:"Trusted by thousand of people all over the world. Good reviews on all social channels."},
    {img:img2,id:"service2", text:"Secured",desc:"Secured blockchain transactions, Secured investors data and personal information Top level ssl certification."},
    {img:img3,id:"service3", text:"Privacy",desc:" All private information remains private. Biggy capital investments never shares   Private information to any third party"},
 ]
 export default serviceData